// extracted by mini-css-extract-plugin
export default {"table":"ServiceOrdersPage_table__TKjcj"};